/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAIImageGenerationBackend;
(function (ApiAIImageGenerationBackend) {
    ApiAIImageGenerationBackend["AI_IMAGE_GENERATION_BACKEND_UNSPECIFIED"] = "AIImageGenerationBackendUnspecified";
    ApiAIImageGenerationBackend["AI_IMAGE_GENERATION_BACKEND_GEMINI_CONTEXT"] = "AIImageGenerationBackendGeminiContext";
    ApiAIImageGenerationBackend["AI_IMAGE_GENERATION_BACKEND_GEMINI_GEN"] = "AIImageGenerationBackendGeminiGen";
})(ApiAIImageGenerationBackend || (ApiAIImageGenerationBackend = {}));
export function ApiAIImageGenerationBackendFromJSON(json) {
    return ApiAIImageGenerationBackendFromJSONTyped(json, false);
}
export function ApiAIImageGenerationBackendFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAIImageGenerationBackendToJSON(value) {
    return value;
}
